/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEmailUpdateRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {GetEmailUpdateResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const getEmailUpdate = (request: GetEmailUpdateRequest, options?: CashRequestOptions) => post<GetEmailUpdateRequest, GetEmailUpdateResponse>("/2.0/cash/get-email-update", request, {...options, rejectOnError: true })